import React, { useState } from 'react'
import { Box, Fab, Tooltip, makeStyles } from '@material-ui/core'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { FaWhatsapp } from 'react-icons/fa'
import { useLocation } from 'react-router-dom'
import useAuth from 'src/hooks/useAuth'
import {
  deveExibirBotaoWhatsapp,
  getLinkWhatsApp,
  WHATSAPP_MENSAGEM_ATENDIMENTO_PADRAO,
  WHATSAPP_SYN_NUMERO
} from 'src/core/consts/whatsapp'

const SESSION_STORAGE_KEY = 'syn_whatsapp_visivel'

function obterVisibilidadeInicial(initialVisible?: boolean): boolean {
  if (typeof initialVisible === 'boolean') {
    return initialVisible
  }
  try {
    const salvo = sessionStorage.getItem(SESSION_STORAGE_KEY)
    if (salvo === 'false') {
      return false
    }
  } catch (e) {
    // ignora restrição de storage
  }
  return true
}

function salvarVisibilidade(visivel: boolean) {
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, visivel ? 'true' : 'false')
  } catch (e) {
    // ignora falha de gravação
  }
}

const useStyles = makeStyles(theme => ({
  container: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    transition: 'right 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    [theme.breakpoints.down('xs')]: {
      bottom: theme.spacing(2),
      right: theme.spacing(2)
    }
  },
  containerEscondido: {
    right: 0,
    [theme.breakpoints.down('xs')]: {
      right: 0
    }
  },
  fabWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 8,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  },
  fabWrapperEscondido: {
    transform: 'translateX(90px) scale(0.6)',
    opacity: 0,
    pointerEvents: 'none',
    width: 0,
    height: 0,
    marginRight: 0,
    overflow: 'hidden'
  },
  fab: {
    backgroundColor: '#25D366',
    color: '#ffffff',
    width: 60,
    height: 60,
    boxShadow:
      '0 4px 14px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(37, 211, 102, 0.4)',
    transition:
      'transform 0.2s ease-in-out, background-color 0.2s, box-shadow 0.2s',
    '&:hover': {
      backgroundColor: '#1EBE5D',
      transform: 'scale(1.08)',
      boxShadow:
        '0 6px 20px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(37, 211, 102, 0.5)'
    },
    '&:active': {
      backgroundColor: '#128C7E',
      transform: 'scale(0.96)'
    }
  },
  icon: {
    fontSize: 34,
    color: '#ffffff'
  },
  toggleBtn: {
    backgroundColor: '#ffffff',
    color: '#25D366',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '50%',
    width: 28,
    height: 28,
    minWidth: 28,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
    transition:
      'all 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s, color 0.2s',
    outline: 'none',
    '&:hover': {
      backgroundColor: '#25D366',
      color: '#ffffff',
      boxShadow: '0 3px 8px rgba(37, 211, 102, 0.4)'
    }
  },
  abaLateralEscondida: {
    backgroundColor: '#25D366',
    color: '#ffffff',
    border: 'none',
    borderRadius: '10px 0 0 10px',
    width: 32,
    height: 46,
    minWidth: 32,
    padding: '0 4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '-2px 2px 8px rgba(0, 0, 0, 0.22)',
    transition: 'all 0.2s ease-in-out',
    outline: 'none',
    '&:hover': {
      backgroundColor: '#1EBE5D',
      width: 36,
      boxShadow: '-3px 3px 12px rgba(37, 211, 102, 0.45)'
    }
  },
  chevronIcon: {
    fontSize: 22
  }
}))

export interface BotaoWhatsappFlutuanteProps {
  numero?: string
  mensagem?: string
  textoTooltip?: string
  forceShow?: boolean
  forceHide?: boolean
  initialVisible?: boolean
  className?: string
  style?: React.CSSProperties
}

export default function BotaoWhatsappFlutuante({
  numero = WHATSAPP_SYN_NUMERO,
  mensagem = WHATSAPP_MENSAGEM_ATENDIMENTO_PADRAO,
  textoTooltip = 'Iniciar atendimento no WhatsApp',
  forceShow = false,
  forceHide = false,
  initialVisible,
  className,
  style
}: BotaoWhatsappFlutuanteProps) {
  const classes = useStyles()
  const location = useLocation()
  const auth = useAuth()
  const signed = auth?.signed
  const perfilAtual = auth?.perfilAtual

  const [visivel, setVisivel] = useState<boolean>(() =>
    obterVisibilidadeInicial(initialVisible)
  )

  if (forceHide) {
    return null
  }

  const deveExibir =
    forceShow || deveExibirBotaoWhatsapp({ signed, perfilAtual })

  if (!deveExibir) {
    return null
  }

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setVisivel(prev => {
      const proximo = !prev
      salvarVisibilidade(proximo)
      return proximo
    })
  }

  const url = getLinkWhatsApp(mensagem, numero)

  return (
    <Box
      className={`${classes.container} ${
        !visivel ? classes.containerEscondido : ''
      } ${className || ''}`}
      style={style}
    >
      {/* Botão de suporte WhatsApp clássico */}
      <div
        className={`${classes.fabWrapper} ${
          !visivel ? classes.fabWrapperEscondido : ''
        }`}
        data-testid="suporte-whatsapp-wrapper"
        aria-hidden={!visivel}
      >
        <Tooltip title={textoTooltip} placement="left" arrow>
          <Fab
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.fab}
            aria-label="Iniciar atendimento no WhatsApp da SYN Saúde"
            data-testid="botao-whatsapp-flutuante"
            tabIndex={visivel ? 0 : -1}
          >
            <FaWhatsapp className={classes.icon} />
          </Fab>
        </Tooltip>
      </div>

      {/* Setinha para esconder ou revelar o botão de suporte */}
      {visivel ? (
        <Tooltip title="Esconder suporte" placement="left" arrow>
          <button
            type="button"
            onClick={handleToggle}
            className={classes.toggleBtn}
            aria-label="Esconder botão de suporte do WhatsApp"
            data-testid="botao-whatsapp-toggle-esconder"
          >
            <ChevronRightIcon className={classes.chevronIcon} />
          </button>
        </Tooltip>
      ) : (
        <Tooltip title="Mostrar suporte WhatsApp" placement="left" arrow>
          <button
            type="button"
            onClick={handleToggle}
            className={classes.abaLateralEscondida}
            aria-label="Mostrar botão de suporte do WhatsApp"
            data-testid="botao-whatsapp-toggle-mostrar"
          >
            <ChevronLeftIcon className={classes.chevronIcon} />
          </button>
        </Tooltip>
      )}
    </Box>
  )
}
